import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewerFeature, ViewerStyles } from '@placeos/svg-viewer';

import { BaseClass } from '@user-interfaces/common';
import { BuildingLevel } from '@user-interfaces/organisation';
import { Space } from '@user-interfaces/spaces';
import { MapPinComponent } from '@user-interfaces/components';

@Component({
    selector: 'view-room-modal',
    template: `
        <header class="h-12 px-4 space-x-2">
            <app-icon
                [icon]="{
                    type: 'icon',
                    class: 'material-icons',
                    content: 'place'
                }"
            ></app-icon>
            <h1>{{ space.name }}</h1>
        </header>
        <div class="relative flex items-center justify-center pointer-events-none" *ngIf="level">
            <i-map
                [src]="level.map_id"
                [styles]="style_map"
                [features]="features"
            >
                <mat-spinner diameter="64"></mat-spinner>
            </i-map>
            <div
                class="absolute top-2 right-2 bg-white py-2 px-4 rounded-3xl shadow"
            >
                {{ level?.name }}
            </div>
        </div>
        <footer class="flex justify-center border-t border-gray-200 p-2">
            <button mat-button class="inverse w-32" mat-dialog-close>Close</button>
        </footer>
    `,
    styles: [
        `
            :host {
                width: auto;
                max-width: none;
            }

            :host > div {
                width: 80vw;
                min-width: 80vw;
                height: 65vh;
            }
        `,
    ],
})
export class ViewRoomModalComponent extends BaseClass implements OnInit {
    /** Emitter for user action on the modal */
    @Output() public event = new EventEmitter();
    /** Space to show the location of on the map */
    public space: Space;
    /** Features of the map */
    public features: ViewerFeature[];
    /** Mapping of elements to CSS styles */
    public style_map: ViewerStyles = {};

    public get level(): BuildingLevel {
        return this.space.level;
    }

    constructor(@Inject(MAT_DIALOG_DATA) private _data: { space: Space }) {
        super();
    }

    public ngOnInit(): void {
        const data = this._data;
        if (data) {
            this.space = data.space;
            this.processStyles();
            setTimeout(() => this.processFeature(), 1000);
        }
    }

    public processStyles(): void {
        const styles: ViewerStyles = {};
        if (this.space.map_id) {
            styles[`#zones`] = { display: 'none' };
            styles[`#Zones`] = { display: 'none' };
        }
        this.style_map = styles;
    }

    /** Point on map to focus on */
    public processFeature(): void {
        if (!this.space) return;
        const focus = {
            location: this.space.map_id,
            content: MapPinComponent,
            data: {
                content: this.space.name,
            },
            zoom: 100,
        };
        this.features = [focus];
    }
}
